<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
// import * as utils from '@/api/utils'
import { Toast } from 'vant'
export default {
  data () {
    return {
      title: '1',
      room_id: null,
      temperature: 20,
      mode: 1, // 1制冷      8制热
      open: true, // 1开        2关
      room: {},
      maxTemp: 30,
      minTempCold: 16,
      minTempHot: 17
    }
  },
  props: {
    roomId: {
      type: Number,
      required: true
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    init () {
      this.init_my_book()
    },
    init_room () {
      const para = {
        // operate_type: ['设置空调', '一键设置空调'],
        // page_no: 1,
        // page_size: 30,
        room_id: this.room_id
      }
      api.axiosRequest(api.urlList.get_air_status, para).then(res => {
        if (res.code === common.resCode.OK) {
          if (res.conditions) {
            const condi = res.conditions[0]
            this.temperature = condi.temperature
            this.open = condi.switch_status === 1
            this.mode = condi.mode
          } else {
          }
        } else {
        }
      })
    },
    change_mode () {
      this.mode = this.mode === 1 ? 8 : 1
      if (this.mode === 8 && this.temperature < this.minTempHot) {
        this.temperature = this.minTempHot
      }
    },
    change_temp (flag) {
      if (flag) {
        if (this.temperature >= this.maxTemp) {
          Toast.fail('已经是最大温度')
          return
        }
        this.temperature = this.temperature + 1
      } else {
        const minTemp = this.mode === 1 ? this.minTempCold : this.minTempHot
        if (this.temperature <= minTemp) {
          Toast.fail('已经时最低温度')
          return
        }
        this.temperature = this.temperature - 1
      }
    },
    change_open (flag) {
      this.open = flag ? 1 : 2
    },
    init_my_book () {
      const curTime = new Date()
      const endTime = new Date()
      const now = new Date()
      curTime.setHours(0)
      curTime.setMinutes(0)
      curTime.setSeconds(0)
      endTime.setHours(23)
      endTime.setMinutes(59)
      endTime.setSeconds(59)
      const para = {
        book_audit_type: true,
        start_time: common.dateFormat(curTime, 'yyyy-MM-dd hh:mm:ss')
      }
      api.axiosRequest(api.urlList.historyOrder, para).then(res => {
        if (res.code === common.resCode.OK) {
          for (let i = 0; i < res.list.length; i++) {
            const item = res.list[i]
            if (item.status === 5 && new Date(item.end_time) > now) {
              this.title = item.building_no + item.name
              this.room_id = item.room_id
              this.room = item
            }
          }
          if (this.room_id) {
            this.init_room()
          } else {
            Toast.fail('暂无可遥控房间')
            this.$router.go(-1)
          }
        }
      })
    },
    setAir () {
      const para = {
        mode: this.mode,
        room_ids: [this.room_id],
        switch: this.open ? 1 : 0,
        temperature: this.temperature
      }
      api.axiosRequest(api.urlList.set_air_status, para).then(res => {
        if (res.code === common.resCode.OK) {
          console.log('设置成功')
        } else {

        }
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<template>
  <div style="width: 100%;height: 100%;overflow: hidden;height: 100%;display: flex;flex-direction: column">
    <van-nav-bar
        title="琴房物联设置"
        left-text=""
        left-arrow
        @click-left="onClickLeft"
    />
    <div class="temperature">
      <div class="state">
        <div class="number">{{temperature}}</div>
        <div class="other">
          <div class="symbol">℃</div>
          <div class="mode">
            <div class="img" :style="`background-image: url(${require(mode === 1 ? '../../assets/imgs/cold_symbol.png' : '../../assets/imgs/hot_symbol.png')})`"/>
            <span>{{mode === 1 ? '制冷' : '制热'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="tip">后续预约的琴房，在签到后，将按此设置开启</div>
    <div class="status">
      <div class="row">
        <div class="left">
          <van-switch v-model="open" active-color="#37da29"></van-switch>
        </div>
        <div class="right" @click="change_mode">
          <span style="font-size: 25px">模式</span>
        </div>
      </div>
      <div class="row">
        <div class="down" @click="change_temp(false)">-</div>
        <div class="text">温度</div>
        <div class="up" @click="change_temp(true)">+</div>
      </div>
    </div>
    <div style="width: 100%;margin-top: 10px;color: red;text-align: center;opacity: 0.7">请设置好空调状态后点击下发按钮进行确认</div>
    <div style="width: 100%;height: 80px;display: flex;justify-content: center;align-items: center;margin-bottom: 31px">
      <van-button type="info" style="width: 92.533%;" color="#74B0F9" @click="setAir">确认</van-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.title {
  width: 100%;
  padding: 5px;
  border-bottom: 1px solid #eee;
}
.tip {
  display: flex;
  width: 100%;
  background: #eeeeee;
  justify-content: center;
  align-items: center;
  color: #999999;
  font-size: 10px;
  line-height: 3;
}
.temperature {
  background: #eeeeee;
  width: 100%;
  height: 20.8365817%;
  //background: red;
  display: flex;
  align-items: center;
  justify-content: center;
  .state {
    display: flex;
    flex-direction: row;
    padding: 0;
    height: 80px;
    width: 100%;
    align-items: center;
    justify-content: center;
    .number {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 80px;
      height: 100%;
    }
    .other {
      margin-left: 10px;
      height: 100%;
      display: flex;
      flex-direction: column;
      .symbol {
        display: flex;
        align-items: center;
        font-size: 21px;
        height: 50%;
      }
      .mode {
        display: flex;
        align-items: center;
        font-size: 16px;
        height: 50%;
        .img {
          width: 16px;
          height: 16px;
          background-image: url("../../assets/imgs/cold_symbol.png");
          background-size: cover;  /* 让图片充满整个 div */
          background-position: center;  /* 保证图片居中显示 */
          background-repeat: no-repeat;  /* 防止图片重复 */
        }
      }
    }
  }
}
.status {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 33.58320%;
  .row {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 50%;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #e0e0e0;
    .left {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #e0e0e0;
    }
    .right {
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .up {
      width: 40%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 10%;
      font-size: 40px;
      box-sizing: border-box;
    }
    .text {
      font-size: 25px;
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .down {
      width: 40%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 10%;
      font-size: 40px;
      box-sizing: border-box;
    }
  }
}
</style>
